import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionLabel } from "@/components/bits";
import { DISCORD_URL } from "@/lib/images";

const FAQS = [
  { q: "Is GZ undetected?", a: "Yes. Every build ships undetected and is monitored 24/7. The moment a game patch or anti-cheat update drops, our team pushes an update. Live status is always visible on the Status page." },
  { q: "How fast is delivery?", a: "Instant. As soon as your payment clears, your license key is generated and available in your account dashboard. NFA accounts are auto-delivered the same way." },
  { q: "What are NFA accounts?", a: "NFA (No-First-Activation / fresh) accounts are clean game accounts with full email access and no prior bans. We stock Call of Duty, Arc Raiders, R6 and Rust." },
  { q: "What is a spoofer and do I need one?", a: "Our HWID spoofer masks your hardware fingerprint so previous bans don't follow you. If you've been hardware-banned, run the spoofer before injecting." },
  { q: "How do creator / staff codes work?", a: "Enter a valid creator code at checkout to receive a discount. It also credits commission to the staff member who owns the code — a win-win." },
  { q: "Which payment methods do you accept?", a: "All major cards via secure Stripe checkout. Your payment details never touch our servers." },
  { q: "Do you offer refunds?", a: "Due to the digital nature of our products, all sales are final once a key is delivered. If a product goes down, we prioritise a fix or credit — reach us on Discord." },
  { q: "How do I get support?", a: "Our team is on Discord 24/7 at discord.gg/injectd. Open a ticket and a real human will help you get set up." },
];

export default function FAQ() {
  return (
    <div className="pt-32 pb-28 mx-auto max-w-[900px] px-5 sm:px-8" data-testid="faq-page">
      <SectionLabel>KNOWLEDGE BASE</SectionLabel>
      <h1 className="mt-4 font-display text-5xl sm:text-7xl uppercase leading-none">FAQ</h1>
      <p className="mt-5 text-white/50">Everything you need to know before you inject.</p>

      <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-lg sm:text-xl uppercase hover:no-underline py-6">
              <span className="flex items-center gap-4">
                <span className="font-mono text-xs text-white/30">{String(i + 1).padStart(2, "0")}</span>
                {f.q}
              </span>
            </AccordionTrigger>
            <AccordionContent className="text-white/55 leading-relaxed text-base pb-6 pl-10">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-14 rounded-2xl border border-white/15 p-8 text-center">
        <p className="text-white/60">Still stuck? Our support team never sleeps.</p>
        <a href={DISCORD_URL} target="_blank" rel="noreferrer" className="btn-inj mt-5 inline-flex px-8 py-4 text-sm">JOIN DISCORD</a>
      </div>
    </div>
  );
}
